import React, { useEffect, useState } from "react";
import { orderList } from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import Header from "../Components/Header";
import { useNavigate } from "react-router-dom";

const SkeletonLoader = () => {
  return (
    <div style={styles.skeletonContainer}>
      {[...Array(12)].map((_, index) => (
        <div key={index} style={styles.skeletonCard}>
          <div style={styles.skeletonRow}></div>
          <div style={styles.skeletonRow}></div>
          <div style={styles.skeletonRow}></div>
          <div style={styles.skeletonRow}></div>
          <div style={styles.skeletonRow}></div>
          <div style={styles.skeletonRow}></div>
        </div>
      ))}
    </div>
  );
};

const OrderHistory = () => {
  const [order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { tokenDetails } = useSelector((state) => state.user);
  const token = tokenDetails;

  useEffect(() => {
    const userOrder = async () => {
      try {
        const response = await orderList(token);
        if (response.success === true) {
          setOrder(response.data);
        }
      } catch (error) {
        console.error("Error getting orders:", error);
      } finally {
        setIsLoading(false);
      }
    };
    userOrder();
  }, [token]);

  if (isLoading) {
    return (
      <div className="add-address-container body-container default is-ctl-home-page is-ctl-landingpage is-ctl-navigation is-act-home">
        
        <div style={styles.container}>
          <h2 style={styles.header} className="middle1">
            Order History
          </h2>
          <SkeletonLoader />
        </div>
      </div>
    );
  }

  const handleCardClick = (id) => {
    navigate("/order-details", { state: { id } });
  };

  return (
    <div className="add-address-container body-container default is-ctl-home-page is-ctl-landingpage is-ctl-navigation is-act-home">
      
      <div style={styles.container}>
        <h2 style={styles.header} className="middle1">
          Order History
        </h2>
        {order.length > 0 ? (
          <div style={styles.grid}>
            {order.map((orderItem, index) => {
              const date = new Date(orderItem.created_at);
              const formattedDate = date.toLocaleDateString();
              const formattedTime = date.toLocaleTimeString();

              return (
                <div
                  key={index}
                  style={styles.card}
                  onClick={() => handleCardClick(orderItem.id)}
                >
                  <div style={styles.row}>
                    <span style={styles.label}>Date:</span>
                    <span style={styles.value}>{formattedDate}</span>
                  </div>
                  <div style={styles.row}>
                    <span style={styles.label}>Time:</span>
                    <span style={styles.value}>{formattedTime}</span>
                  </div>
                  <div style={styles.row}>
                    <span style={styles.label}>Order Type:</span>
                    <span style={styles.value}>{orderItem.order_type}</span>
                  </div>
                  <div style={styles.row}>
                    <span style={styles.label}>Order Status:</span>
                    <span
                      style={{
                        ...styles.value,
                        color:
                          orderItem.order_status === "Pending"
                            ? "#ff4d4f"
                            : "#28a745",
                      }}
                    >
                      {orderItem.order_status}
                    </span>
                  </div>
                  <div style={styles.row}>
                    <span style={styles.label}>Total Amount:</span>
                    <span style={styles.value}>${orderItem.total_amount}</span>
                  </div>
                  <div style={styles.row}>
                    <span style={styles.label}>Payment Status:</span>
                    <span
                      style={{
                        ...styles.value,
                        color:
                          orderItem.payment_status === "Pending"
                            ? "#ff4d4f"
                            : "#28a745",
                      }}
                    >
                      {orderItem.payment_status}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p style={styles.noData}>No orders found.</p>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "90%",
    margin: "20px auto",
    textAlign: "center",
    marginTop: "93px",
  },
  header: {
    fontSize: "34px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "20px",
    textAlign: "center",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
  },
  card: {
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "pointer",
    textAlign: "left",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
    fontSize: "16px",
  },
  label: {
    fontWeight: "bold",
    color: "#555",
  },
  value: {
    color: "#333",
  },
  noData: {
    fontSize: "18px",
    color: "#888",
    marginTop: "20px",
  },
  skeletonContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
  },
  skeletonCard: {
    padding: "20px",
    backgroundColor: "#f0f0f0",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  skeletonRow: {
    height: "16px",
    backgroundColor: "#e0e0e0",
    borderRadius: "4px",
    marginBottom: "10px",
    animation: "pulse 1.5s infinite ease-in-out",
  },
};

export default OrderHistory;